import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    GET_USER_LIST_FAILURE,
    GET_USER_LIST_SUCCESS
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

import {
    getUserListService,
} from 'src/pages/more/pages/templates/redux/services/index.js';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* getUserList(action) {
    try {
        const result = yield getUserListService(
            convertObjectToQueryParams({
                networkIdName: action.payload
                    ? action.payload.networkIdName
                    : '',
                accountNameId: action.payload
                    ? action.payload.accountNameId
                    : '',
                pageNum: action.payload ? action.payload.pageNum : 0,
                pageSize: 2000,
                isTemplateSharePage:true,
                sortOrder: action.payload && action.payload.sortOrder,
                sortParams: 'name',
                // salesOrgs: action.payload
                //     ? action.payload.salesOrgFilter.name
                //     : '',
                district: action.payload ? action.payload.filteredDistrict : '',
                territory: action.payload
                    ? action.payload.filteredTerritory
                    : '',
                userRoles: action.payload ? action.payload.filteredRole : '',
            })
        );

        yield put({
            type: GET_USER_LIST_SUCCESS,
            adminUserList: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/users`,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_USER_LIST_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}